import { render, staticRenderFns } from "./GolfSkillsAssessmentDetails.vue?vue&type=template&id=467966c1&scoped=true&"
import script from "./GolfSkillsAssessmentDetails.vue?vue&type=script&lang=js&"
export * from "./GolfSkillsAssessmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./GolfSkillsAssessmentDetails.vue?vue&type=style&index=0&id=467966c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467966c1",
  null
  
)

export default component.exports